import { Link } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { actionStartBankId } from "../redux/actions/loanApplicationAction";

interface Props {
  linkText: string;
  type: string;
  textType?: string;
}

const CheckLoanStatusLink = ({ linkText, type, textType }: Props) => {
  const dispatch = useDispatch();
  const onLoginClick = () => {
    dispatch(actionStartBankId("", "", type));
  };
  return (
    <Link onClick={onLoginClick} color={textType} style={{ cursor: "pointer" }}>
      {linkText}
    </Link>
  );
};

export default CheckLoanStatusLink;
